import { styled } from '@linaria/react'
import dashboardBackground from '../../../../assets/img/dashboard-background.svg';

export const DashboardAcquisitionContainer = styled.div`
    background-color: #ebf1ff;
    background-image: url(${dashboardBackground});
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
`;
